export default function EmpathySection() {
  const worries = [
    {
      icon: 'ri-plant-line',
      title: '庭の草が伸び放題で、もう手に負えない…',
      desc: '岡山県南部は温暖な気候で草の成長が早く、水路沿いの湿気で雑草が一気に繁茂します。腰や膝が痛くて、以前のように庭仕事ができなくなってきた。',
      who: '70代・岡山市南区在住',
    },
    {
      icon: 'ri-bug-line',
      title: 'ゴキブリやムカデが出て、怖くて眠れない夜がある',
      desc: '水路が多い岡山南部では、湿気を好む害虫が侵入しやすい環境です。毎年夏になると不安で、市販の薬を使っても追いつかない。',
      who: '65代・倉敷市在住',
    },
    {
      icon: 'ri-home-gear-line',
      title: '雨漏りや壁のひびが気になるけど、どこに頼めばいいか…',
      desc: '小さな不具合を放置すると大きな修繕費になる。でも業者を探して見積もりを取るのが面倒で、ついつい後回しにしてしまう。',
      who: '75代・玉野市在住',
    },
    {
      icon: 'ri-heart-line',
      title: '離れて暮らす親の家が心配で、仕事中も気になってしまう',
      desc: '実家に帰るたびに家が傷んでいて胸が痛い。でも遠方に住んでいて頻繁には行けない。親に無理させたくないし、かといって自分では対応できない。',
      who: '50代・東京在住（親が岡山市在住）',
    },
  ];

  return (
    <section id="empathy" aria-label="お悩みへの共感セクション" className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-amber-700 text-sm font-semibold tracking-widest mb-3 uppercase">
            こんなお悩みありませんか？
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-stone-800 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            岡山県南部で暮らす方々の<br />
            <span className="text-amber-700">リアルな声</span>
          </h2>
          <p className="mt-4 text-stone-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            温暖な気候と水路が多い岡山南部ならではの悩みを、私たちは15年間聞き続けてきました。
          </p>
        </div>

        {/* Worry Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {worries.map((w, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 md:p-7 border border-stone-100 hover:border-amber-200 transition-colors"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-50 rounded-full shrink-0">
                  <i className={`${w.icon} text-amber-600 text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-stone-800 font-bold text-sm md:text-base leading-snug mb-2">
                    {w.title}
                  </h3>
                  <p className="text-stone-500 text-xs md:text-sm leading-relaxed mb-3">{w.desc}</p>
                  <span className="inline-block text-xs text-amber-700 bg-amber-50 px-3 py-1 rounded-full">
                    {w.who}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bridge Text */}
        <div className="mt-14 text-center">
          <div className="inline-block bg-amber-600 text-white rounded-lg px-8 py-5 max-w-2xl">
            <p className="text-base md:text-lg font-bold leading-relaxed">
              そのお悩み、すべて<strong>「家の管理おまかせパック」</strong>が解決します。<br />
              <span className="text-amber-100 text-sm font-normal mt-1 block">
                害虫・庭・清掃・点検・補修をワンストップで。月額9,800円から。
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
